import React from 'react'
import GenericGrid from '../../sharedcomponents/5templates/commonGrid/GenericGrid'
import GridWrapper from '../../sharedcomponents/5templates/commonGrid/GridWrapper'
import useGridWrapper from '../../sharedcomponents/5templates/commonGrid/useGridWrapper'
import useGroup from './useGroup'

const MixedGroups = () => {
  const defaultFetchParameter = {
    include: ['counts'],
    sort: '+name',
    page: 0,
    per_page: 20
  }
  const {
    typeIdToDisplayName,
    loadGroups,
    bulkUpdateGroupsCallBack,
    groupTypes
  } = useGroup()
  const {
    editMode,
    setEditMode,
    isSnackbarOpen,
    setIsSnackbarOpen,
    deletionChanges,
    deleteCallBack,
    activationChanges,
    activationCallBack,
    detailCallBack,
    addCallBack,
    handSaveCallback,
    isGridDirty
  } = useGridWrapper('Group', bulkUpdateGroupsCallBack)
  const visibleColumns = [
    { field: 'name', headerName: 'Name', width: 150, sortable: true },
    {
      field: 'type',
      headerName: 'Group Type',
      width: 150,
      sortable: true
    },
    {
      field: 'description',
      headerName: 'Description',
      width: 400,
      sortable: true
    },
    {
      field: '$user',
      headerName: 'Assigned Users',
      width: 150,
      sortable: true
    },

    {
      field: '$feature',
      headerName: 'Assigned Features',
      width: 150,
      sortable: true
    },
    {
      field: '$datazone',
      headerName: 'Assigned Datazones',
      width: 150,
      sortable: true
    },
    {
      field: '$inherited',
      headerName: 'Assigned Groups',
      width: 150,
      sortable: true
    },
    {
      field: 'active',
      headerName: 'Status',
      width: 200,
      sortable: true,
      isToggle: true
    }
  ]
  const fetchCallBack = async arg => {
    const {
      data: { data, pagination, sort } = {
        data: [],
        pagination: {},
        sort: {}
      },
      isError,
      isLoading,
      isFetching
    } = await loadGroups(arg)
    // transform the server-provided array for display

    const rows = []
    data.forEach(one => {
      rows.push({
        id: one.id, //please note, the underlying datagrid assumes the id column is always called id
        name: one.name,
        type: typeIdToDisplayName(one.type),
        description: one.description,
        $user: one.object_counts.find(r => r.type === 'user').count,
        $datazone: one.object_counts.find(r => r.type === 'datazone').count,
        $feature: one.object_counts.find(r => r.type === 'feature').count,
        $inherited: one.object_counts.find(r => r.type === 'inherited').count,
        active: one.suspended_at ? false : true,
        is_system: one.is_system
      })
    })
    return {
      newRows: rows,
      newPagination: pagination,
      newSort: sort,
      newLoading: isLoading || isFetching,
      newError: isError
    }
  }

  return (
    <div style={{ height: '100%', width: '100%' }}>
      <div style={{ height: '100%', width: '100%' }}>
        <GridWrapper
          header={'Access Management'}
          editMode={editMode}
          setEditMode={setEditMode}
          isSnackbarOpen={isSnackbarOpen}
          setIsSnackbarOpen={setIsSnackbarOpen}
          isGridDirty={isGridDirty}
          addCallBack={addCallBack}
          listOfTypes={groupTypes}
          typeToTypeDisplayName={typeIdToDisplayName}
          handleSave={handSaveCallback}
        >
          <GenericGrid
            initialFetchParameters={defaultFetchParameter}
            visibleColumns={visibleColumns}
            editMode={editMode}
            fetchCallBack={fetchCallBack}
            detailCallBack={detailCallBack}
            deleteCallBack={deleteCallBack}
            activationCallBack={activationCallBack}
            deletionChanges={deletionChanges}
            activationChanges={activationChanges}
          />
        </GridWrapper>
      </div>
    </div>
  )
}
export default React.memo(MixedGroups)
